import { IBulkBatch } from "@wingspanhq/payments/dist/interfaces";
import { useQueryFlatfileSkippedRowsCount } from "../query/flatfile/queries";
import { BulkResource } from "../types";
import { getUploadRejectedRowsCount } from "../utils/bulkBatchUtils";

/**
 * Number of uploaded spreadsheet rows that did not make it into the batch.
 *
 * Prefers the live Flatfile count, which sees both the rows that failed validation and the rows the
 * Wingspan API refused, and falls back to the `flatfileRejectedRowsCount` batch label - which only
 * ever counted the latter - when Flatfile cannot be reached. The label is durable, so an old batch
 * whose space is gone keeps reporting what it reports today instead of dropping to nothing.
 */
export function useSkippedRowsCount(
  bulkBatch?: IBulkBatch,
  bulkResource?: BulkResource
): number {
  const queryFlatfileSkippedRowsCount = useQueryFlatfileSkippedRowsCount(
    bulkBatch,
    bulkResource
  );

  return (
    queryFlatfileSkippedRowsCount.data ?? getUploadRejectedRowsCount(bulkBatch)
  );
}
